import SectionHeading from "./SectionHeading";

const items = [
  {
    img: "https://readdy.ai/api/search-image?query=Editorial%20flat%20lay%20about%20removed%20short%20drama%20content%20and%20download%20takedown%2C%20folded%20posters%20and%20closed%20folder%20on%20warm%20desk%2C%20minimal%20newsroom%20style%2C%20soft%20light%2C%20beige%20background%2C%20no%20faces%2C%20detailed&width=480&height=360&seq=takedown-row-01&orientation=landscape",
    alt: "短剧下架事件小图",
    time: "今日 09:20",
    tag: "短剧类",
    title: "涉「诱导充值」短剧被批量下架，下架范围仍在扩大",
    brief: "多部付费短剧因剧情诱导被移出平台。官方称依据内容规范处理，有观众质疑下架是否连带误伤普通剧集。",
    actions: "讨论 342",
  },
  {
    img: "https://readdy.ai/api/search-image?query=Conceptual%20image%20of%20moderated%20and%20removed%20comments%20and%20blocked%20words%20on%20short%20video%20app%2C%20chat%20bubble%20and%20lock%20icon%20in%20warm%20tones%20with%20dark%20accent%2C%20minimal%20documentary%20aesthetic%2C%20clean%20background%2C%20no%20people%2C%20high%20detail&width=480&height=360&seq=takedown-row-02&orientation=landscape",
    alt: "评论屏蔽下架事件小图",
    time: "昨日 22:05",
    tag: "评论区",
    title: "多条涉敏感表述评论被隐藏，屏蔽词表再成焦点",
    brief: "网友反映部分评论未提示原因即被折叠或删除，平台称属系统审核。审核尺度的可解释性，讨论仍在升温。",
    actions: "讨论 590",
  },
  {
    img: "https://readdy.ai/api/search-image?query=Editorial%20image%20about%20content%20with%20copyright%20dispute%20being%20taken%20down%20on%20platform%2C%20documents%20and%20magnifier%20on%20warm%20neutral%20surface%2C%20minimal%20news%20style%2C%20soft%20lighting%2C%20beige%20background%2C%20no%20faces%2C%20detailed&width=480&height=360&seq=takedown-row-03&orientation=landscape",
    alt: "搬运维权下架事件小图",
    time: "前天 17:40",
    tag: "搬运维权",
    title: "「搬运混剪」集中下架，原创作者的举报到底有多少被采纳",
    brief: "一批搬运混剪视频因侵权被处理，创作者披露举报反馈率低。平台回应称会提升维权响应效率，效果待观察。",
    actions: "讨论 128",
  },
];

export default function TakedownList() {
  return (
    <section id="takedown" className="w-full border-y border-background-200/70 bg-background-100">
      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          kicker="内容下架记录"
          title="下架事件 · 逐条归档"
          desc="短剧、评论区、搬运维权——不同形态的内容因何被下架？把每一次处理的时间、类型与各方解释排在一起对比。"
        />

        <div className="mt-8 flex flex-col gap-4">
          {items.map((it) => (
            <article
              key={it.title}
              className="group flex flex-col gap-4 overflow-hidden rounded-xl border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 sm:flex-row sm:items-center"
            >
              <div className="relative w-full shrink-0 overflow-hidden rounded-lg bg-background-200 sm:w-52 lg:w-60">
                <img
                  src={it.img}
                  alt={it.alt}
                  className="h-44 w-full object-cover object-top transition-transform duration-300 group-hover:scale-105 sm:h-28"
                />
                <span className="absolute left-2 top-2 inline-flex items-center whitespace-nowrap rounded-full bg-foreground-950/70 px-2 py-0.5 text-[11px] text-background-50 backdrop-blur">
                  {it.tag}
                </span>
              </div>

              <div className="flex flex-1 flex-col">
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-time-line" /> {it.time}
                  </span>
                  <span className="inline-flex h-4 w-px bg-background-300" />
                  <span className="whitespace-nowrap">下架类型 · {it.tag}</span>
                </div>
                <h3 className="mt-1.5 font-label text-base font-semibold leading-snug text-foreground-950 group-hover:text-primary-700">
                  {it.title}
                </h3>
                <p className="mt-1.5 text-[13px] leading-relaxed text-foreground-600">{it.brief}</p>
                <div className="mt-3 flex flex-wrap items-center gap-3 text-xs">
                  <span className="whitespace-nowrap text-primary-600">围观讨论 →</span>
                  <span className="inline-flex items-center gap-1 whitespace-nowrap text-foreground-500">
                    <i className="ri-chat-3-line" /> {it.actions}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}